import {Payable, PaymentDate} from "./Payable";
import {IncomingInvoiceId} from "./IncomingInvoice";
import {Identifier} from "../common/Identifier";
import {Module} from "../common/Module";
import {Nullable} from "../common/Nullable";
import {AuthenticatedUser} from "../users/AuthenticatedUser";
import {isPrivileged, isPrivilegedByIdentifier, Privileges} from "../../config/Privileges";
import {ACCOUNTING_AREA_TYPE_NAME} from "./AccountBook";
import {Person} from "../common/Person";


export const IncomingInvoicePaymentModule: Module = {
    identifier: 'incoming_invoice_payment',
    isPrivileged: (authUser: Nullable<AuthenticatedUser>, privilege: string, privilegeIdentifier?: string) => {

        if (typeof privilegeIdentifier !== "undefined") {
            return isPrivilegedByIdentifier(authUser, privilegeIdentifier);
        } else {
            return isPrivileged(
                authUser,
                ACCOUNTING_AREA_TYPE_NAME,
                IncomingInvoicePaymentModule.identifier,
                privilege
            );
        }
    }
};


export interface IncomingInvoicePaymentIdProp {
    incomingInvoicePaymentId: Identifier<number>
}

export interface IncomingInvoicePayment extends Payable, PaymentDate, IncomingInvoiceId {
    id: Identifier<number>
    payedBy: Person
}

export function isIncomingInvoicePayment( payment: any ): payment is IncomingInvoicePayment {
    return payment.hasOwnProperty( "id" ) && payment.hasOwnProperty( "payedAmount" );
}